
export enum Active {
    InActive = 0,
    Active = 1,
    All = 2
}
